/**
 * Skeleton loading components for smooth loading states.
 */

interface TaskListSkeletonProps {
  count?: number;
}

export function TaskListSkeleton({ count = 3 }: TaskListSkeletonProps) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <TaskCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function TaskCardSkeleton() {
  return (
    <div className="bg-surface-raised border border-rule rounded-lg overflow-hidden">
      <div className="pl-4 pr-3 py-3">
        {/* Top row */}
        <div className="flex items-start justify-between gap-2 mb-2">
          <div className="space-y-1.5">
            <div className="skeleton h-4 w-24" />
            <div className="skeleton h-3 w-16" />
          </div>
          <div className="skeleton h-5 w-16 rounded" />
        </div>

        {/* Description */}
        <div className="space-y-1.5 mb-3">
          <div className="skeleton h-3.5 w-full" />
          <div className="skeleton h-3.5 w-2/3" />
        </div>

        {/* Bottom row */}
        <div className="flex items-center justify-between gap-2">
          <div className="skeleton h-5 w-28" />
          <div className="skeleton h-4 w-12" />
        </div>
      </div>
    </div>
  );
}
